import { createSlice } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import {
  finalStatusListThunk,
  saveOrUpdateCaseThunk,
  closeOrReOpenCaseThunk,
  typeOfOrderThunk,
} from "./thunk";
const saveOrUpdateCaseInitialState = {
  status: "idle",
  data: {},
  error: {},
};

const closeOrReOpenCaseInitialState = {
  status: "idle",
  data: {},
  error: {},
};
const finalStatusListInitialState = {
  status: "idle",
  data: {},
  error: {},
};
const typeOfOrderInitialState = {
  status: "idle",
  data: {},
  error: {},
};
const closeOrReOpenCaseSlice = createSlice({
  name: "closeOrReOpenCase",
  initialState: closeOrReOpenCaseInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(closeOrReOpenCaseThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(closeOrReOpenCaseThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(closeOrReOpenCaseThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});
const saveOrUpdateCaseSlice = createSlice({
  name: "saveOrUpdateCase",
  initialState: saveOrUpdateCaseInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveOrUpdateCaseThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(saveOrUpdateCaseThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(saveOrUpdateCaseThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const finalStatusListSlice = createSlice({
  name: "finalStatusList",
  initialState: finalStatusListInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(finalStatusListThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(finalStatusListThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(finalStatusListThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

const typeOfOrderSlice = createSlice({
  name: "typeOfOrder",
  initialState: typeOfOrderInitialState,
  reducers: {
    reset: (state) => {
      state.status = "idle";
      state.data = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(typeOfOrderThunk.pending, (state) => {
        state.status = "pending";
      })
      .addCase(typeOfOrderThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })

      .addCase(typeOfOrderThunk.rejected, (state, action) => {
        state.status = "failed";
        state.data = {};
        state.error = action.payload.error;
      });
  },
});

export const { reset: resetSaveOrUpdateCase } = saveOrUpdateCaseSlice.actions;
export const { reset: resetCloseOrReOpenCase } = closeOrReOpenCaseSlice.actions;
export const { reset: resetFinalStatusList } = finalStatusListSlice.actions;
export const { reset: resetTypeOfOrder } = typeOfOrderSlice.actions;

const reducers = combineReducers({
  finalStatusList: finalStatusListSlice.reducer,
  typeOfOrder: typeOfOrderSlice.reducer,
  saveOrUpdateCase: saveOrUpdateCaseSlice.reducer,
  closeOrReOpenCase: closeOrReOpenCaseSlice.reducer,
});

export default reducers;
